import { useQuery } from '@apollo/client';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import type {
  UseDegreePlanQuery as UseDegreePlanQueryData,
  UseDegreePlanQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useDegreePlan';
import UseDegreePlanQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useDegreePlan.graphql';

const useDegreePlan = () => {
  const { degreeId } = useDegreeContext();

  const variables: UseDegreePlanQueryVariables = {
    degreeId,
  };

  const { refetch, ...queryResult } = useQuery<UseDegreePlanQueryData, UseDegreePlanQueryVariables>(
    UseDegreePlanQuery,
    {
      variables,
      context: { clientName: 'gatewayGql' },
    }
  );
  return { refetch, ...queryResult };
};

export default useDegreePlan;
